import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { UiKit } from 'components';

/**
 * @param {Object} props
 * @param {function | null} [props.onConfirm]
 * @param {import('utils/types').ButtonVariant} [props.confirmBtnVariant]
 * @param {string} [props.confirmBtnText]
 * @param {boolean} [props.isConfirmDisabled]
 * @param {boolean} [props.hideCancelBtn]
 * @param {string} [props.cancelBtnText]
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.children]
 */
export default function SheetFooter({
  onConfirm = null,
  confirmBtnVariant = 'primary',
  confirmBtnText = 'Confirm',
  isConfirmDisabled = false,
  hideCancelBtn = false,
  cancelBtnText = 'Cancel',
  className = '',
  children = null
}) {
  return (
    <UiKit.Modal.Footer
      btnSize="lg"
      onConfirm={onConfirm}
      confirmBtnVariant={confirmBtnVariant}
      confirmBtnText={confirmBtnText}
      isConfirmDisabled={isConfirmDisabled}
      hideCancelBtn={hideCancelBtn}
      cancelBtnText={cancelBtnText}
      className={cn(styles.footer, className)}
    >
      {children}
    </UiKit.Modal.Footer>
  );
}
